<work-view
  [backlogTasks]="(workContextService.backlogTasks$ | async) || []"
  [doneTasks]="(workContextService.doneTasks$ | async) || []"
  [isShowBacklog]="false"
  [undoneTasks]="(workContextService.undoneTasks$ | async) || []"
></work-view>
